import useApi from '../utils/axios-pettitions';
import { SqlRowEdit } from '../types/types.sqlEditor';

export const useApiSqlEditor = () => {
  const { runApi } = useApi();

  const stepHeader = (unlockToken?: string): Record<string, string> | undefined =>
    unlockToken ? { 'X-Sql-Stepup': unlockToken } : undefined;

  // Esquema de la BD (para el árbol de tablas y el autocompletado).
  const getSchema = () => runApi('SqlEditor/schema', 'GET', null, null);

  // Ejecuta un SELECT seguro. 'signal' permite cancelar la ejecución (botón detener).
  const query = (sql: string, maxRows?: number, signal?: AbortSignal) =>
    runApi('SqlEditor/query', 'POST', null, { Sql: sql, MaxRows: maxRows }, undefined, signal);

  // Edición estructurada por PK/insert/delete (requiere step-up).
  const applyEdits = (table: string, edits: SqlRowEdit[], unlockToken: string, signal?: AbortSignal) =>
    runApi('SqlEditor/apply-edits', 'POST', null, { Table: table, Edits: edits }, stepHeader(unlockToken), signal);

  // Dry-run de una escritura cruda (rollback), para confirmar impacto.
  const preview = (sql: string, unlockToken: string, signal?: AbortSignal) =>
    runApi('SqlEditor/preview', 'POST', null, { Sql: sql }, stepHeader(unlockToken), signal);

  // Ejecuta una escritura cruda (UPDATE/DELETE/INSERT) con límites.
  const execute = (sql: string, maxAffected: number | undefined, unlockToken: string, signal?: AbortSignal) =>
    runApi('SqlEditor/execute', 'POST', null, { Sql: sql, MaxAffectedRows: maxAffected }, stepHeader(unlockToken), signal);

  // Definición editable (ALTER VIEW) de una vista.
  const getViewDefinition = (name: string) =>
    runApi('SqlEditor/view-definition', 'GET', { name }, null);

  // Aplica un CREATE/ALTER VIEW (requiere step-up).
  const executeDdl = (sql: string, unlockToken: string, signal?: AbortSignal) =>
    runApi('SqlEditor/execute-ddl', 'POST', null, { Sql: sql }, stepHeader(unlockToken), signal);

  // Verifica el código TOTP y devuelve un unlock token.
  const stepUpVerify = (code: string) =>
    runApi('SqlEditor/stepup/verify', 'POST', null, { Code: code });

  // Auditoría.
  const getAudit = (take: number, skip: number) =>
    runApi('SqlEditor/audit', 'GET', { take, skip }, null);

  return { getSchema, query, applyEdits, preview, execute, getViewDefinition, executeDdl, stepUpVerify, getAudit };
};
